/**
 * session_storage — 로그인 세션 영속(sessionStorage) 헬퍼.
 *
 * useTransportLogin(로그인/로그아웃)과 useVehicleSessionGate(콕핏 나가기=완전 로그아웃)이
 * 동일한 키를 쓰도록 한 곳으로 모았다. 의존성 없는 경량 모듈.
 */
import type { AuthCredentials } from "../../interface/auth_types";

const KEY_SUCCESS = "login_success";
const KEY_ID = "login_id";
const KEY_PASSWORD = "login_password";

export function clearStoredSession(): void {
  sessionStorage.removeItem(KEY_SUCCESS);
  sessionStorage.removeItem(KEY_ID);
  sessionStorage.removeItem(KEY_PASSWORD);
}

export function persistSession(credentials: AuthCredentials): void {
  sessionStorage.setItem(KEY_SUCCESS, "true");
  sessionStorage.setItem(KEY_ID, credentials.userId);
  sessionStorage.setItem(KEY_PASSWORD, credentials.password);
}

export function readStoredCredentials(): AuthCredentials | null {
  const success = sessionStorage.getItem(KEY_SUCCESS);
  const storedId = sessionStorage.getItem(KEY_ID);
  const storedPassword = sessionStorage.getItem(KEY_PASSWORD);
  if (!success || !storedId || !storedPassword) {
    return null;
  }

  return {
    userId: storedId,
    password: storedPassword,
  };
}
